export const getRadioValue = (val, type = 'value') => {
    return val.find((v) => v.checked)?.[type] ?? '';
};
